import { render, staticRenderFns } from "./DefaultMechanism.vue?vue&type=template&id=02022612"
import script from "./DefaultMechanism.vue?vue&type=script&lang=js"
export * from "./DefaultMechanism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports